export const HTML_FONT_SIZE = 16;
export const THEME_SPACING = 8;
export const pxToRem = (px: number): string => `${px / HTML_FONT_SIZE}rem`;
export const pxToSpacing = (px: number): number => px / THEME_SPACING;
